import { useSelector } from "react-redux"
import { accountSelector } from "../../store/account/selectors"

export default () => {
  return useSelector(accountSelector)
}
